import { render, staticRenderFns } from "./shouhou.vue?vue&type=template&id=caa847fe&scoped=true"
import script from "./shouhou.vue?vue&type=script&lang=js"
export * from "./shouhou.vue?vue&type=script&lang=js"
import style0 from "./shouhou.vue?vue&type=style&index=0&id=caa847fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa847fe",
  null
  
)

export default component.exports